import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
interface IconifyProps {
  icon: string;
  sx?: object;
  width?: number | string;
  height?: number | string;
  color?: string;
  onClick?: () => void;
}

export default function Iconify({ icon, sx = {}, width, height, color, onClick }: IconifyProps) {
  return (
    <Box
      component={Icon}
      icon={icon}
      sx={{
        fontSize: 20,
        minWidth: 20,
        minHeight: 20,
        width: 20,
        height: 20,
        ...sx, // allow override
      }}
      width={width}
      height={height || width}
      color={color}
      onClick={onClick}
    />
  );
}
